<template>
  <component :is="tag" class="link-text">
    <template v-for="(segment, index) in segments" :key="index">
      <a
        v-if="segment.isLink"
        class="link-text__link"
        :href="segment.value"
        target="_blank"
        rel="noopener noreferrer"
      >{{ segment.value }}</a>
      <span v-else>{{ segment.value }}</span>
    </template>
  </component>
</template>

<script>
const URL_RE = /(?:https?|ftp):\/\/[0-9A-Za-z](?:[-.\w]*[0-9A-Za-z])*(?::\d+)?(?:\/[A-Za-z0-9\-._~:/?#[\]@!$&'()*+,;=%]*)?/gi

function parseSegments(text) {
  const value = String(text || '')
  if (!value) return []

  const segments = []
  let lastIndex = 0
  let match

  URL_RE.lastIndex = 0
  while ((match = URL_RE.exec(value)) !== null) {
    const start = match.index
    const end = start + match[0].length

    if (start > lastIndex) {
      segments.push({ value: value.slice(lastIndex, start), isLink: false })
    }

    segments.push({ value: match[0], isLink: true })
    lastIndex = end
  }

  if (lastIndex < value.length) {
    segments.push({ value: value.slice(lastIndex), isLink: false })
  }

  return segments
}

export default {
  name: 'LinkText',
  props: {
    text: {
      type: String,
      default: '',
    },
    tag: {
      type: String,
      default: 'span',
    },
  },
  computed: {
    segments() {
      return parseSegments(this.text)
    },
  },
}
</script>

<style scoped>
.link-text {
  white-space: pre-wrap;
  word-break: break-word;
}

.link-text__link {
  color: #2563eb;
  text-decoration: none;
}

.link-text__link:hover {
  text-decoration: underline;
}
</style>
